import React from "react";

import SubBoxWrapper from "../../wrapper/SubBoxWrapper";

import NoItem from "../util/NoItem";
import ListItem from "./ListItem";

function Qna({ menuLink, qnaList, titleText, noItemText, menuTypeCode, info, drawCd }) {
    return (
        <SubBoxWrapper
            info={info}
            titleText={titleText}
            menuLink={menuLink}
            menuTypeCode={menuTypeCode}
            customClassName={"notifiCation"}
            drawCd={drawCd}
        >
            {qnaList ? (
                qnaList.map((info, idx) => (
                    <ListItem
                        key={idx}
                        titleText={info.NAME}
                        contentText={info.CNTT}
                        dateText={info.DTM}
                        link={info.LINK}
                    ></ListItem>
                ))
            ) : (
                <NoItem titleText={noItemText} />
            )}
        </SubBoxWrapper>
    );
}

export default Qna;
